var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetadata(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "#EDF2F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41016 4.95545C3.41016 4.42777 3.83793 4 4.36561 4H4.75358C5.28126 4 5.70903 4.42777 5.70903 4.95545C5.70903 5.48314 5.28126 5.9109 4.75358 5.9109H4.36561C3.83793 5.9109 3.41016 5.48314 3.41016 4.95545ZM7.9461 4.95545C7.9461 4.42777 8.37376 4 8.90155 4H15.632C16.1597 4 16.5875 4.42777 16.5875 4.95545C16.5875 5.48314 16.1597 5.9109 15.632 5.9109H8.90155C8.37376 5.9109 7.9461 5.48314 7.9461 4.95545ZM3.41016 10.0007C3.41016 9.473 3.83793 9.04521 4.36561 9.04521H4.75358C5.28126 9.04521 5.70903 9.473 5.70903 10.0007C5.70903 10.5283 5.28126 10.9561 4.75358 10.9561H4.36561C3.83793 10.9561 3.41016 10.5283 3.41016 10.0007ZM7.9461 10.0007C7.9461 9.473 8.37376 9.04521 8.90155 9.04521H15.632C16.1597 9.04521 16.5875 9.473 16.5875 10.0007C16.5875 10.5283 16.1597 10.9561 15.632 10.9561H8.90155C8.37376 10.9561 7.9461 10.5283 7.9461 10.0007ZM3.41016 15.0445C3.41016 14.5169 3.83793 14.0891 4.36561 14.0891H4.75358C5.28126 14.0891 5.70903 14.5169 5.70903 15.0445C5.70903 15.5722 5.28126 16 4.75358 16H4.36561C3.83793 16 3.41016 15.5722 3.41016 15.0445ZM7.9461 15.0445C7.9461 14.5169 8.37376 14.0891 8.90155 14.0891H15.632C16.1597 14.0891 16.5875 14.5169 16.5875 15.0445C16.5875 15.5722 16.1597 16 15.632 16H8.90155C8.37376 16 7.9461 15.5722 7.9461 15.0445Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/metadata.77bfe66969bb1bd7f3b19e417932336f.svg";
export { ForwardRef as ReactComponent };